import Input from './input';
import InputSelect from './inputSelect';
import SimpleCheckbox from './simpleCheckbox';

export default function InputGroup({
  label,
  labelClassName = '',
  fields,
  className,
  disabled,
  ...props
}) {
  return (
    <div className={`my-2 ${className}`}>
      {label && <label className={labelClassName}>{label}</label>}
      {fields.map((field, index) => {
        if (field.type === 'select') {
          return <InputSelect key={index} className="my-2" disabled={disabled} {...field} />;
        }

        if (field.type === 'checkbox') {
          return <SimpleCheckbox key={index} className="my-2" disabled={disabled} {...field} />;
        }

        return <Input key={index} className="my-2" disabled={disabled} {...field} />;
      })}
      <div className="">
        <p className="text-xs">Max. 90 characters</p>
      </div>
    </div>
  );
}
